import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon, LockIcon } from 'lucide-react';
import { policies } from '../data/business';
import { CURRENCY_NOTE } from '../data/books';
import { SectionHeading } from './SectionHeading';
export function Policies() {
  const [open, setOpen] = useState<string | null>(policies[0].id);
  return <section id="policies" className="w-full bg-paper py-28" data-id="element-206" data-mp="1uhtx66xh82zy">
      <div className="mx-auto max-w-4xl px-6" data-id="element-207" data-mp="297hvczad2ljg">
        <SectionHeading eyebrow="Customer Policies" title="Buying from us" description="Our full refund, cancellation, shipping, and privacy terms — written plainly, so you know exactly where you stand before you order." data-id="element-208" data-mp="249q5sbx6vbif" />

        <div className="mt-12 flex items-start gap-3 border border-gold/40 bg-parchment/60 p-5" data-id="element-209" data-mp="2daxp9nv1q7sg">
          <LockIcon className="text-gold mt-0.5 shrink-0" size={18} data-id="element-210" data-mp="nvzykwarw74k" />
          <p className="text-ink/70 text-sm leading-relaxed" data-id="element-211" data-mp="ix6m97782m5z">
            {CURRENCY_NOTE} Payments are processed securely by Stripe over an
            encrypted HTTPS connection.
          </p>
        </div>

        <div className="mt-10 divide-y divide-ink/10 border-y border-ink/10" data-id="element-212" data-mp="3sukm1yc0ywx6">
          {policies.map(policy => {
          const isOpen = open === policy.id;
          return <article key={policy.id} id={policy.id} data-id="element-213" data-mp="6e6kegob3djg">
                <h3 data-id="element-214" data-mp="6g145rnuczly">
                  <button onClick={() => setOpen(isOpen ? null : policy.id)} aria-expanded={isOpen} aria-controls={`${policy.id}-panel`} className="w-full flex items-center justify-between gap-6 py-6 text-left group" data-id="element-215" data-mp="afs52o730w47">
                    <span className="font-serif text-2xl text-ink group-hover:text-gold transition-colors" data-id="element-216" data-mp="pd2ezt42ttxt">
                      {policy.title}
                    </span>
                    <ChevronDownIcon size={20} className={`shrink-0 text-gold transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-217" data-mp="2r45ryp1fvklj" />
                  </button>
                </h3>

                {isOpen && <motion.div id={`${policy.id}-panel`} initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-218" data-mp="2t2oxux8v7n6q">
                    <div className="pb-8" data-id="element-219" data-mp="2x2hbhod48jiy">
                      <p className="text-ink/75 leading-relaxed" data-id="element-220" data-mp="3bs5ceohdxg65">
                        {policy.summary}
                      </p>
                      <ul className="mt-5 space-y-3" data-id="element-221" data-mp="36ssftc0pouqd">
                        {policy.points.map(point => <li key={point} className="flex gap-3 text-ink/70 text-sm leading-relaxed" data-id="element-222" data-mp="3ktuzxj85buyn">
                            <span aria-hidden="true" className="mt-2 h-1 w-1 shrink-0 bg-gold" data-id="element-223" data-mp="39wb8oqya3kq" />
                            <span data-id="element-224" data-mp="3qfdgz6g6un95">{point}</span>
                          </li>)}
                      </ul>
                    </div>
                  </motion.div>}
              </article>;
        })}
        </div>

        <p className="mt-10 text-ink/60 text-sm leading-relaxed" data-id="element-225" data-mp="3gmy0kdkji6qd">
          Questions about any of the above? Reach our customer support team using
          the contact details{' '}
          <a href="#contact" className="text-gold hover:underline" data-id="element-226" data-mp="37q76g6pjt1yf">
            below
          </a>
          .
        </p>
      </div>
    </section>;
}